@if (shouldShow()) {
  <db-tag
    size="small"
    type="soft"
    [text]="label()"
    [color]="color()"
    [iconUrl]="iconUrl()"
    [pTooltip]="isMeetingRoom() ? undefined : tooltipText()"
    tooltipPosition="top"
  />
}
